/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import '../assets/css/style.css'
import ncBankLogo from '../assets/img/logo/footer_logo_ncbank.jpg'
import ncBankLogo2 from '../assets/img/logo/footer_logo_ncbank@2x.jpg'
import namLogo from '../assets/img/logo/footer_logo_nomura-am.jpg'
import namLogo2 from '../assets/img/logo/footer_logo_nomura-am@2x.jpg'
import { useDealerCode } from '../hook/useDealerCode'

export const Footer = React.memo(() => {
  const dealerCode = useDealerCode()
  return (
    <footer className="l-footer">
      <div className="l-footer__inner">
        <div className="l-footer__grid">
          {dealerCode === 'ncbank' && (
            <div className="l-footer__grid__col">
              <p className="l-footer__logo">
                <a target="_blank" rel="noopener noreferrer" href="https://www.ncbank.co.jp/">
                  <img
                    src={ncBankLogo}
                    // eslint-disable-next-line max-len
                    srcSet={`${ncBankLogo} 1x,${ncBankLogo2} 2x`}
                    alt="西日本シティ銀行"
                    width="221"
                    height="38"
                  />
                </a>
              </p>
              <dl className="l-footer__data">
                <dt>商　　号：</dt>
                <dd>
                  株式会社西日本シティ銀行
                  <br />
                  登録金融機関　福岡財務支局長（登金）第6号
                </dd>
              </dl>
              <dl className="l-footer__data--indent">
                <dt>加入協会：</dt>
                <dd>
                  日本証券業協会 ／<br />
                  一般社団法人金融先物取引業協会
                </dd>
              </dl>
            </div>
          )}
          <div className="l-footer__grid__col">
            <p className="l-footer__logo">
              <a target="_blank" rel="noopener noreferrer" href="https://www.nomura-am.co.jp/">
                <img
                  src={namLogo}
                  // eslint-disable-next-line max-len
                  srcSet={`${namLogo} 1x,${namLogo2} 2x`}
                  alt="野村アセットマネジメント"
                  width="280"
                  height="38"
                />
              </a>
            </p>
            <dl className="l-footer__data">
              <dt>商　　号：</dt>
              <dd>
                野村アセットマネジメント株式会社
                <br />
                金融商品取引業者 関東財務局長（金商）第373号
              </dd>
            </dl>
            <dl className="l-footer__data">
              <dt>金融商品取引業の種別：</dt>
              <dd>投資運用業、投資助言・代理業、第二種金融商品取引業</dd>
            </dl>
            <dl className="l-footer__data--indent">
              <dt>加入協会：</dt>
              <dd>
                一般社団法人資産運用業協会／
                <br />
                一般社団法人第二種金融商品取引業協会
              </dd>
            </dl>
          </div>
          <div className="l-footer__grid__col">
            <p>
              <a
                href="https://www.nomura-am.co.jp/risk_cost.html"
                target="_blank"
                rel="noopener noreferrer"
                className="l-footer__text-link"
              >
                野村アセットマネジメント
                <br />
                からのお知らせ
              </a>
            </p>
          </div>
        </div>
        <p className="l-footer__copy">
          <small>COPYRIGHT(C) NOMURA ASSET MANAGEMENT CO., LTD. ALL RIGHTS RESERVED.</small>
        </p>
      </div>
    </footer>
  )
})
